import { create } from 'zustand';

export interface QueueState {
  profile: any;
  game: any; // Cambia a tipo adecuado si tienes la interfaz
  position: number;
  retryIn: number;
  lastTried: number; // timestamp
}

interface GlobalQueueStore {
  queues: QueueState[];
  timer: Record<string, number>;
  setQueue: (queue: QueueState) => void;
  removeQueue: (profileId: string) => void;
  getQueue: (profileId: string) => QueueState | undefined;
  updateQueue: (profileId: string, data: Partial<QueueState>) => void;
  clearAll: () => void;
  setTimer: (profileId: string, value: number) => void;
  getTimer: (profileId: string) => number;
}

export const useQueueStore = create<GlobalQueueStore>((set, get) => ({
  queues: [],
  timer: {},
  setTimer: (profileId, value) => {
    set((state) => {
      const newTimer = { ...state.timer, [profileId]: value };
      // console.log('setTimer', profileId, value, newTimer);
      return { timer: newTimer };
    });
  },
  getTimer: (profileId) => {
    const t = get().timer[profileId] ?? 0;
    // console.log('getTimer', profileId, t);
    return t;
  },

  setQueue: (queue) => {
    // console.log('setQueue called', queue);
    set((state) => {
      const filtered = state.queues.filter(q => q.profile.id !== queue.profile.id);
      // Devuelve un nuevo array para forzar actualización
      const newQueues = [...filtered, { ...queue }].slice(-4);
      const newTimer = { ...state.timer, [queue.profile.id]: queue.retryIn };
      // console.log('setQueue newQueues', newQueues, 'newTimer', newTimer);
      return { queues: newQueues, timer: newTimer };
    });
  },
  removeQueue: (profileId) => {
    set((state) => {
      const newQueues = state.queues.filter(q => q.profile.id !== profileId);
      const newTimer = { ...state.timer };
      delete newTimer[profileId];
      // console.log('removeQueue newQueues', newQueues, 'newTimer', newTimer);
      return { queues: newQueues, timer: newTimer };
    });
  },
  getQueue: (profileId) => {
    const queue = get().queues.find(q => q.profile.id === profileId);
    // console.log('getQueue', profileId, queue);
    return queue;
  },
  updateQueue: (profileId, data) => {
    set((state) => {
      const newQueues = state.queues.map(q => q.profile.id === profileId ? { ...q, ...data } : { ...q });
      // console.log('updateQueue newQueues', newQueues);
      return { queues: newQueues };
    });
  },
  clearAll: () => {
    set({ queues: [], timer: {} });
  }
}),
);
